
import { defineComponent } from "vue";

export default defineComponent({
  name: "PendingItem",
  props: {
    caption: String,
  },
});
